<template>
<div>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>
  <base-alert-dialog
    :show="dialog.show"
    :variant="dialog.variant"
    :title="dialog.title"
    :message="dialog.message"
    :show-cancel="dialog.showCancel"
    :confirm-text="dialog.confirmText"
    :confirm-variant="dialog.confirmVariant"
    @confirm="onDialogConfirm"
    @cancel="dialog.show = false"
  />
  <div class="row mt-2">
    <div class="col-12">
      <card card-body-classes="table-full-width">
        <tab-rail
          class="mb-3"
          :tabs="categories"
          :value="activeTabIndex"
          @input="switchTab"
        >
          <template #actions>
            <base-button size="sm" class="d-none d-sm-inline-block" v-on:click="createSchedule()" type="primary" >
              <i class="tim-icons icon-simple-add mr-2"></i> Create schedule</base-button>
            <base-button size="sm" icon class="d-inline-block d-sm-none" v-on:click="createSchedule()" type="primary" >
              <i class="tim-icons icon-simple-add"></i></base-button>

            <el-tooltip content="More actions"
                        effect="light"
                        :open-delay="300"
                        placement="top">
              <el-dropdown>
                <base-button
                  simple
                  type="primary"
                  link
                > <i style="font-size: large"  class="tim-icons el-icon-more"></i>
                </base-button>
                <template #dropdown>
                  <el-dropdown-menu>
                    <a class="dropdown-item" v-on:click="clearSchedulesModal()" href="#">
                      <i class="tim-icons icon-refresh-01 mr-2"></i> Clear manually created slots
                    </a>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </el-tooltip>
          </template>
        </tab-rail>
        <div v-if="activeTabIndex === 0">
          <div v-if="booking_schedules.length <= 0" class="sl-empty-state mt-4">
            <img src="/img/pandas/schedule.png" alt="No booking schedules" class="empty-state-img" />
            <h4 class="empty-state-text">No booking schedules yet</h4>
            <p class="sl-empty-state__hint">
              Booking schedules define when your games can be booked by customers. Create one to start generating available time slots.
            </p>
          </div>

          <div class="row" v-if="booking_schedules.length > 0">
            <div class="col d-sm-none d-block">
              <b-table  striped hover :items="booking_schedules"
                        :fields="['schedules']">
                <template v-slot:cell(schedules)="row">
                  <div class="row">
                    <div class="col">
                      {{row.item.name}}
                      <base-button v-if="row.item.active"
                                   @click="activateSchedulePrompt('deactivate', row.item)"
                                   icon
                                   class="like btn-link"
                                   size="sm"
                      ><span class="active-dot"></span>
                      </base-button>
                      <base-button v-if="!row.item.active"
                                   @click="activateSchedulePrompt('activate', row.item)"
                                   icon
                                   class="like btn-link"
                                   size="sm"
                      ><span class="inactive-dot"></span>
                      </base-button>
                    </div>
                    <div class="col text-right">
                      <badge type="default" v-if="row.item.is_recurring == 2">Closed period</badge>
                      <badge type="default" v-if="row.item.is_recurring == 1">Always recurring</badge>
                      <badge type="default" v-if="row.item.is_recurring == 0">Finite</badge>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col">
                      <small v-if="row.item.start_date">{{getDate(row.item.start_date)}}
                        <small v-if="row.item.end_date && row.item.is_recurring !== 1"> - {{getDate(row.item.end_date)}}</small>
                      </small>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col">
                      <span class="mr-1" v-for="(a, i) in getActiveDays(row.item)" :key="i">
                        <badge type="default">{{a}}</badge>
                      </span>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col">
                      <badge v-for="(game, index) in JSON.parse(row.item.games)" :key="'G' + index" class="mr-3" type="primary">{{game.name}}</badge>
                    </div>
                  </div>
                  <div class="row mt-1" v-if="creationDone(row.item) && isAutoblocking(row.item)">
                    <div class="col">
                      <small class="text-muted">Blocking time slots...</small>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div
                        class="btn-group btn-group-toggle mt-3"
                        :class="'float-left'"
                        data-toggle="buttons" style="width:100%; max-width: 100%"
                      >
                        <label class="btn btn-sm btn-primary btn-simple">
                          <base-button style="padding-left: 0; padding-right: 0"
                                       @click.native="deleteSchedule(row.item, $event)"
                                       type="primary"
                                       class="btn btn-link"
                                       size="sm"
                                       icon
                          ><i class="tim-icons icon-trash-simple"></i>
                          </base-button>
                        </label>
                        <label class="btn btn-sm btn-primary btn-simple">
                          <base-button style="padding-left: 0; padding-right: 0"
                                       @click.native="editSchedule(row.item, $event)"
                                       type="primary"
                                       class="btn btn-link"
                                       size="sm"
                                       icon
                          ><i class="tim-icons icon-pencil"></i>
                          </base-button>
                        </label>
                        <label class="btn btn-sm btn-primary btn-simple">
                          <base-button style="padding-left: 0; padding-right: 0"
                                       @click.native="copyScheduleTemplate(row.item, $event)"
                                       type="primary"
                                       class="btn btn-link"
                                       size="sm"
                                       icon
                          ><i class="tim-icons icon-single-copy-04"></i>
                          </base-button>
                        </label>
                      </div>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="col d-sm-block d-none">
              <b-table striped hover :items="booking_schedules"
                        :fields="fields">
                <template v-slot:cell(name)="row">
                  <span>
                    {{row.item.name}}
                  </span>
                </template>
                <template v-slot:cell(status)="row">
                  <div v-if="!row.item.record_creation_completed && (row.item.expected_number_of_records > 0 || !row.item.expected_number_of_records)">
                    <div class="progress-bar-container">
                      <div class="progress-bar-striped"></div>
                    </div>
                    <small class="text-muted">Generating...</small>
                  </div>
                  <div v-if="creationDone(row.item) && isAutoblocking(row.item)">
                    <div class="progress-bar-container">
                      <div class="progress-bar-striped"></div>
                    </div>
                    <small class="text-muted">Blocking time slots...</small>
                  </div>
                  <badge type="success" v-if="creationDone(row.item) && !isAutoblocking(row.item) && row.item.active">active</badge>
                  <badge type="danger" v-if="creationDone(row.item) && !isAutoblocking(row.item) && !row.item.active">deactivated</badge>
                </template>
                <template v-slot:cell(start_date)="row">
                  <span v-if="row.item.start_date">{{getDate(row.item.start_date)}}</span>
                  <span v-if="!row.item.start_date">-</span>
                </template>
                <template v-slot:cell(end_date)="row">
                  <span v-if="row.item.end_date && row.item.is_recurring !== 1">{{getDate(row.item.end_date)}}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:cell(schedule_duration)="row">
                  <span v-if="row.item.is_recurring == 2">Closed period</span>
                  <span v-if="row.item.is_recurring == 1">Always recurring</span>
                  <span v-if="row.item.is_recurring == 0">Finite</span>
                </template>
                <template v-slot:cell(active_days)="row">
                  <span v-if="getActiveDays(row.item).length <= 0">-</span>
                  <span v-for="(a, i) in getActiveDays(row.item)" :key="i">
                    {{a}}
                  </span>
                </template>
                <template v-slot:cell(assigned_games)="row">
                  <span v-if="!row.item.games">-</span>
                  <badge v-else v-for="(game, index) in JSON.parse(row.item.games)" :key="'G' + index" class="mr-3" type="primary">{{game.name}}</badge>
                </template>

                <template v-slot:cell(actions)="row">
                  <el-dropdown v-if="row.item.record_creation_completed || (row.item.expected_number_of_records > 0 && row.item.created_number_of_records >= row.item.expected_number_of_records)">
                    <base-button
                      link
                      type="primary"
                      size="sm"
                    > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                    </base-button>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <a class="dropdown-item mb-2"  v-if="row.item.active" @click="activateSchedulePrompt('deactivate', row.item, $event)" href="#">
                          <i class="tim-icons text-default icon-button-power mr-2"></i> Deactivate schedule
                        </a>
                        <a class="dropdown-item mb-2"  v-if="!row.item.active" @click="activateSchedulePrompt('activate', row.item, $event)" href="#">
                          <i class="tim-icons text-default icon-button-power mr-2"></i> Activate schedule
                        </a>
                        <a class="dropdown-item mb-2" @click="editSchedule(row.item, $event)" href="#">
                          <i class="tim-icons text-default icon-pencil mr-2"></i> Edit schedule
                        </a>
                        <a class="dropdown-item" @click="copyScheduleTemplate(row.item, $event)" href="#">
                          <i class="tim-icons text-default icon-single-copy-04 mr-2"></i> Save as new schedule
                        </a>
                        <hr>
                        <a class="dropdown-item" @click="deleteSchedule(row.item, $event)" href="#">
                          <i class="tim-icons text-default icon-trash-simple mr-2"></i> Delete schedule
                        </a>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div v-if="activeTabIndex === 1">
          <!--  Feature not enabled-->
<!--          <div v-if="feature_not_enabled" class="mt-3" >-->
<!--            <div class="font-icon-detail">-->
<!--            <span style="font-size: 3em">-->
<!--              <i class="fas fa-exclamation-triangle"></i>-->
<!--            </span>-->
<!--              <h4 class="mt-3">This feature is not enabled.</h4>-->
<!--              <base-button type="primary" v-if="hasPermissions('billing_view')"-->
<!--                           v-on:click="goToBilling()" class="mt-3">Enable feature</base-button>-->
<!--              <p style="font-size: medium" v-else>Please contact a site administrator to activate.</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div v-if="!feature_not_enabled">-->
            <div v-if="resource_schedules.length <= 0" class="sl-empty-state mt-4">
              <img src="/img/pandas/schedule.png" alt="No resource schedules" class="empty-state-img" />
              <h4 class="empty-state-text">No resource schedules yet</h4>
              <p class="sl-empty-state__hint">
                Resource schedules define when rooms, equipment, and other resources are available. Create one to control their availability.
              </p>
            </div>
            <div class="row" v-if="resource_schedules.length > 0">
              <div class="col d-sm-none d-block">
                <b-table  striped hover :items="resource_schedules"
                          :fields="['schedules']">
                  <template v-slot:cell(schedules)="row">
                    <div class="row">
                      <div class="col">
                        {{row.item.name}}
                        <base-button v-if="row.item.active"
                                     @click="activateSchedulePrompt('deactivate', row.item)"
                                     icon
                                     class="like btn-link"
                                     size="sm"
                        ><span class="active-dot"></span>
                        </base-button>
                        <base-button v-if="!row.item.active"
                                     @click="activateSchedulePrompt('activate', row.item)"
                                     icon
                                     class="like btn-link"
                                     size="sm"
                        ><span class="inactive-dot"></span>
                        </base-button>
                      </div>
                      <div class="col text-right">
                        <badge type="default" v-if="row.item.is_recurring == 2">Closed period</badge>
                        <badge type="default" v-if="row.item.is_recurring == 1">Always recurring</badge>
                        <badge type="default" v-if="row.item.is_recurring == 0">Finite</badge>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col">
                        <small v-if="row.item.start_date">{{getDate(row.item.start_date)}}
                          <small v-if="row.item.end_date && row.item.is_recurring !== 1"> - {{getDate(row.item.end_date)}}</small>
                        </small>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col">
                      <span class="mr-1" v-for="(a, i) in getActiveDays(row.item)" :key="i">
                        <badge type="default">{{a}}</badge>
                      </span>
                      </div>
                    </div>
                    <div class="row mt-1" v-if="creationDone(row.item) && isAutoblocking(row.item)">
                      <div class="col">
                        <small class="text-muted">Blocking time slots...</small>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div
                          class="btn-group btn-group-toggle mt-3"
                          :class="'float-left'"
                          data-toggle="buttons" style="width:100%; max-width: 100%"
                        >
                          <label class="btn btn-sm btn-primary btn-simple">
                            <base-button style="padding-left: 0; padding-right: 0"
                                         @click.native="deleteSchedule(row.item, $event)"
                                         type="primary"
                                         class="btn btn-link"
                                         size="sm"
                                         icon
                            ><i class="tim-icons icon-trash-simple"></i>
                            </base-button>
                          </label>
                          <label class="btn btn-sm btn-primary btn-simple">
                            <base-button style="padding-left: 0; padding-right: 0"
                                         @click.native="editSchedule(row.item, $event)"
                                         type="primary"
                                         class="btn btn-link"
                                         size="sm"
                                         icon
                            ><i class="tim-icons icon-pencil"></i>
                            </base-button>
                          </label>
                          <label class="btn btn-sm btn-primary btn-simple">
                            <base-button style="padding-left: 0; padding-right: 0"
                                         @click.native="copyScheduleTemplate(row.item, $event)"
                                         type="primary"
                                         class="btn btn-link"
                                         size="sm"
                                         icon
                            ><i class="tim-icons icon-single-copy-04"></i>
                            </base-button>
                          </label>
                        </div>
                      </div>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="col d-sm-block d-none">
                <b-table  striped hover :items="resource_schedules"
                          :fields="['name', 'start_date', 'end_date', 'schedule_duration', 'active_days', 'status', 'actions']">
                  <template v-slot:cell(title)="row">
              <span>
                {{row.item.name}}
              </span>
                  </template>
                  <template v-slot:cell(start_date)="row">
                    <span v-if="row.item.start_date">{{getDate(row.item.start_date)}}</span>
                    <span v-if="!row.item.start_date">-</span>
                  </template>
                  <template v-slot:cell(status)="row">
                    <div v-if="!row.item.record_creation_completed && (row.item.expected_number_of_records > 0 || !row.item.expected_number_of_records)">
                      <div class="progress-bar-container">
                        <div class="progress-bar-striped"></div>
                      </div>
                      <small class="text-muted">Generating...</small>
                    </div>
                    <div v-if="creationDone(row.item) && isAutoblocking(row.item)">
                      <div class="progress-bar-container">
                        <div class="progress-bar-striped"></div>
                      </div>
                      <small class="text-muted">Blocking time slots...</small>
                    </div>
                    <badge type="success" v-if="creationDone(row.item) && !isAutoblocking(row.item) && row.item.active">active</badge>
                    <badge type="danger" v-if="creationDone(row.item) && !isAutoblocking(row.item) && !row.item.active">deactivated</badge>
                  </template>
                  <template v-slot:cell(end_date)="row">
                    <span v-if="row.item.end_date && row.item.is_recurring !== 1">{{getDate(row.item.end_date)}}</span>
                    <span v-else>-</span>
                  </template>
                  <template v-slot:cell(schedule_duration)="row">
                    <span v-if="row.item.is_recurring == 2">Closed period</span>
                    <span v-if="row.item.is_recurring == 1">Always recurring</span>
                    <span v-if="row.item.is_recurring == 0">Finite</span>
                  </template>
                  <template v-slot:cell(active_days)="row">
                    <span v-if="getActiveDays(row.item).length <= 0">-</span>
                    <span v-for="(a, i) in getActiveDays(row.item)" :key="i">
                    {{a}}
                </span>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <el-dropdown v-if="row.item.record_creation_completed || (row.item.expected_number_of_records > 0 && row.item.created_number_of_records >= row.item.expected_number_of_records)">
                      <base-button
                        link
                        type="primary"
                        size="sm"
                      > <i style="font-size: large" class="tim-icons el-icon-more"></i>
                      </base-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <a class="dropdown-item mb-2"  v-if="row.item.active" @click="activateSchedulePrompt('deactivate', row.item, $event)" href="#">
                            <i class="tim-icons text-default icon-button-power mr-2"></i> Deactivate schedule
                          </a>
                          <a class="dropdown-item mb-2"  v-if="!row.item.active" @click="activateSchedulePrompt('activate', row.item, $event)" href="#">
                            <i class="tim-icons text-default icon-button-power mr-2"></i> Activate schedule
                          </a>
                          <a class="dropdown-item mb-2" @click="editSchedule(row.item, $event)" href="#">
                            <i class="tim-icons text-default icon-pencil mr-2"></i> Edit schedule
                          </a>
                          <a class="dropdown-item" @click="copyScheduleTemplate(row.item, $event)" href="#">
                            <i class="tim-icons text-default icon-single-copy-04 mr-2"></i> Save as new schedule
                          </a>
                          <hr>
                          <a class="dropdown-item" @click="deleteSchedule(row.item, $event)" href="#">
                            <i class="tim-icons text-default icon-trash-simple mr-2"></i> Delete schedule
                          </a>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
<!--        </div>-->
      </card>
    </div>
  </div>

  <!--    Clear schedules-->
  <modal :show.sync="modals.clear_schedules"
         body-classes="p-0"
         modal-classes="modal-dialog-centered modal-lg">
    <card type="secondary"
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">

      <h4>Clear manually created booking slots</h4>
      <div class="row">
        <div class="col">
          <base-alert type="info">
            <i class="tim-icons el-icon-info mr-1"></i> <span style="font-weight: bold">Note:</span>  this will clear all future booking slots that were created manually
            and are not associated with a schedule. All other booking slots can be removed by deleting the associated schedule.</base-alert>
        </div>
      </div>
      <div class="row">
        <div class="col" >
          <base-input label="Games">
            <el-select
              label="Select game"
              v-model="cleared_games"
              class="select-primary"
              value-key="id"
              multiple
            >
              <el-option
                v-for="(game, i) in games"
                class="select-primary"
                :label="game.name"
                :value="{ name: game.name, id: game.id}"
                :key="'G' + i"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <label>Booking slot status</label>
      <div class="row">
        <div class="col">
          <base-checkbox v-model="cleared_status.available">Available</base-checkbox>
          <base-checkbox v-model="cleared_status.block">Blocked</base-checkbox>
          <base-checkbox v-model="cleared_status.call_to_book">Call to book</base-checkbox>
          <base-checkbox v-model="cleared_status.requestable">Requestable</base-checkbox>
        </div>
      </div>

      <div class="row d-none d-sm-block text-center mt-3">
        <base-button type="secondary" @click="modals.clear_schedules = false">Cancel</base-button>
        <base-button class="ml-3" type="primary" @click="clearSchedules()">Clear</base-button>
      </div>
      <div class="row d-block d-sm-none text-center mt-3">
        <base-button simple size="sm" type="secondary" @click="modals.clear_schedules = false">Cancel</base-button>
        <base-button simple size="sm" class="ml-3" type="primary" @click="clearSchedules()">Clear</base-button>
      </div>
    </card>
  </modal>

    <review-future-slots-drawer
    :show="modals.future_slots"
    :rows="future_slots"
    :insufficient-resources="has_insufficient_resource_slots > 0"
    :loading="loading"
    confirm-label="Activate schedule"
    @close="modals.future_slots = false"
    @confirm="modals.future_slots = false; activateSchedule('activate', selectedSchedule)"
  />
</div>
</template>

<script>
import {API_LOCATION} from "@/api-config";
import {Auth} from "aws-amplify";
import {BTable} from "bootstrap-vue";
import {formattedDate} from "@/plugins/dateFormatter";
import {Badge, BaseAlert} from '@/components'
import {Dropdown, DropdownItem, DropdownMenu, Switch} from 'element-ui';
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import TabRail from '@/components/TabRail.vue';
import ReviewFutureSlotsDrawer from '@/components/ReviewFutureSlotsDrawer.vue';
import { buildFutureSlotRows, hasFutureSlotConflicts, buildFutureSlotFlags } from '@/util/scheduleFutureSlots';

export default {
  name: "ScheduleList",
  components: {
    ReviewFutureSlotsDrawer,
    TabRail,
    BTable,
    Badge,
    BaseAlert,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Switch.name]: Switch,
  },
  data() {
    return {
      polling: null,
      // Keep polling briefly after load or activate: the workflow marks a schedule as
      // generating ~1s after the request returns, so the first fetch can see nothing yet.
      poll_grace_until: 0,
      feature_not_enabled: false,
      all_complete: 1,
      has_insufficient_resource_slots: 0,
      settings: {
        resource_autoblock_enabled: false
      },
      selectedSchedule: '',
      future_slots: buildFutureSlotRows({}),
      dialog: {
        show: false,
        variant: 'warning',
        title: '',
        message: '',
        showCancel: false,
        confirmText: 'Ok',
        confirmVariant: 'primary',
        onConfirm: null
      },
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      loading: false,
      activeTabIndex: 0,
      booking_schedules: [],
      resource_schedules: [],
      fields: ['name', 'start_date', 'end_date', 'schedule_duration', 'active_days', 'assigned_games', 'status', 'actions'],
      games: [],
      modals: {
        clear_schedules: false,
        future_slots: false
      },
      cleared_games: '',
      cleared_status: {
        available: false,
        block: false,
        call_to_book: false,
        requestable: false
      },
    }
  },
  computed: {
    categories() {
      return [
        { name: 'Booking schedules', shortName: 'Booking' },
        { name: 'Resource schedules', shortName: 'Resource' },
      ];
    },
  },
  methods: {
    showDialog(opts) {
      this.dialog = Object.assign({ showCancel: false, confirmText: 'Ok', confirmVariant: 'primary', onConfirm: null }, opts, { show: true })
    },
    onDialogConfirm() {
      const action = this.dialog.onConfirm
      this.dialog.show = false
      this.dialog.onConfirm = null
      if (action) action()
    },
    async copyScheduleTemplate(item, event){
      event.preventDefault()

      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/schedules/' + item.id

      let data = {}

      this.loading = true
      this.axios.post(url, data, config)
        .then(response => {
          this.$router.push({ path: '/bookings/schedules/edit', query: { id:  response.data }})

        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status === 500){
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    async checkFutureSlots(action, schedule){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let dt = new Date()
      let today = dt.getFullYear() + '-' +  ('0' + (dt.getMonth()+1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)
      let gameIds = []
      if(schedule.hasOwnProperty('games')){
        for(let n in JSON.parse(schedule.games)){
          gameIds.push(JSON.parse(schedule.games)[n].id)
        }
      }

      let sd = schedule.start_date ? moment(schedule.start_date, 'YYYY-MM-DD') : moment()
      let ed =  schedule.end_date ? moment(schedule.end_date, 'YYYY-MM-DD') : moment()

      if(schedule.is_recurring === 1){
        sd = moment()
        ed = sd.clone().add(365, 'days');
      }

      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId +
        '/schedules/check-future-slots'

      const data = {
        today: today,
        start_date: sd.format('YYYY-MM-DD'),
        end_date: ed.format('YYYY-MM-DD'),
        games: gameIds,
        resources: '[]'
      }

      this.selectedSchedule = schedule
      this.loading = true
      this.axios.post(url, data, config)
        .then(response => {
          if(!hasFutureSlotConflicts(response.data)){
            // Keep the loader up: the run turns it off when it finishes
            this.activateSchedule(action, schedule)
            return
          }
          this.future_slots = buildFutureSlotRows(response.data)
          this.has_insufficient_resource_slots = response.data.insufficient_resources > 0 ? 1 : 0
          this.loading = false
          this.modals.future_slots = true
        })
        .catch(err => {
          this.loading = false
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else if (err.response.status === 500){
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })

    },
    activateSchedulePrompt(action, item, event){
      event.preventDefault()
      let html = ''
      if(item.type === 0 && action === 'deactivate'){
        html = 'Deactivating the schedule will remove all future unbooked slots created by this schedule.'
      }
      else if (item.type === 0 && action === 'activate'){
        html = 'Activating the schedule will create live booking slots for the valid schedule period.'
      }
      else if (item.type === 1 && action === 'deactivate'){
        html = 'Deactivating the schedule will remove all future resource slots created by this schedule.'
      }
      else if (item.type === 1 && action === 'activate'){
        html = 'Activating the schedule will create live resource slots for the valid schedule period.'
      }
      this.showDialog({
        variant: 'warning',
        title: 'Are you sure?',
        message: html,
        showCancel: true,
        confirmText: 'Continue',
        confirmVariant: 'primary',
        onConfirm: () => {
          if(action === 'activate' && item.type === 0){
            this.checkFutureSlots('activate', item)
          } else {
            this.activateSchedule(action, item);
          }
        }
      })

    },
    async activateSchedule(action, item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let groupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/schedules/' + item.id + '/activate'
      let time = new Date()

      let data = {
        active:  action === 'activate' ? 1 : 0,
        ...buildFutureSlotFlags(this.future_slots),
        time: time.getFullYear() + '-' + (time.getMonth()+1) + '-' + time.getDate(),
      }

      this.poll_grace_until = Date.now() + 15000
      if (this.polling) clearInterval(this.polling)
      this.polling = setInterval(this.getSchedules, 3000);

      axios.post(url, data, config)
        .then(response => {
          this.modals.future_slots = false
          this.loading = false
          this.showDialog({ variant: 'success', title: 'Success', message: `Schedule has been ` + action + `d` })
          this.getSchedules()

        }).catch((err) => {
        console.log(err)
        this.loading = false
        if(err.response.status == 401){
          this.$router.push('/forbidden')
        } else if (err.response.status === 500){
          this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
        }
      })
    },
    editSchedule(item, event){
      event.preventDefault()
      this.$router.push({ path: '/bookings/schedules/edit', query: { id: item.id, type: item.type }})
    },
    createSchedule(){
      this.$router.push('/bookings/schedules/create')
    },
    getErrorMessage(err, fallback = 'Something went wrong') {
      const raw = err.response?.data
      let parsed = raw
      if (typeof raw === 'string') {
        try { parsed = JSON.parse(raw) } catch (e) { parsed = { error: raw } }
      }
      return parsed?.error || fallback
    },
    deleteSchedule(item, event) {
      event.preventDefault()
      this.showDialog({
        variant: 'warning',
        title: 'Are you sure?',
        message: `The schedule will be permanently deleted`,
        showCancel: true,
        confirmText: 'Yes, delete it!',
        confirmVariant: 'danger',
        onConfirm: () => {
          this.delete(item);
        }
      })
    },
    async delete(item){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules/' + item.id
      let current = new Date()
      current = current.getFullYear() + '-' + (current.getMonth()+1) + '-' + current.getDate()

      this.axios.delete(url, config)
        .then(response => {
          this.showDialog({ variant: 'success', title: 'Success', message: `Schedule deleted.` })
          this.getSchedules()
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response?.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: this.getErrorMessage(err) })
          }
        })
    },
    async clearSchedules(){
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let groupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + groupId + '/schedules/clear-booking-slots'
      let date = new Date()
      date = date.getFullYear() + '-' +  ('0' + (date.getMonth()+1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)

      let data = {
        games:  this.cleared_games,
        status: this.cleared_status,
        current_date: date
      }

      axios.post(url, data, config)
        .then(response => {
          this.cleared_games = ''
          this.cleared_status = {
            available: false,
            block: false,
            call_to_book: false,
            requestable: false
          }
          this.modals.clear_schedules = false
          this.loading = false
          this.showDialog({ variant: 'success', title: 'Success', message: `Booking slots have been removed.` })

        }).catch((err) => {
        console.log(err)
        this.loading = false
        if(err.response.status == 401){
          this.$router.push('/forbidden')
        }
      })
    },
    clearSchedulesModal(){
      this.modals.clear_schedules = true
    },
    switchTab(index){
      this.activeTabIndex = index
    },
    creationDone(item){
      return item.record_creation_completed || (item.expected_number_of_records > 0 && item.created_number_of_records >= item.expected_number_of_records)
    },
    isAutoblocking(item){
      return item.autoblocking_completed === 0
    },
    getActiveDays(item){
      //order slots by id
      let arr = JSON.parse(item.slots)
      arr.sort(function (a,b) {
        if(a.start_day === 0){
          a.start_day = 7
        }
        if(b.start_day === 0){
          b.start_day = 7
        }
        return a.start_day - b.start_day;
      });

      let activeDays = []
      let dupes = [false, false, false, false, false, false, false]
      for(let n in arr){
        if((arr[n].start_day === 1 || arr[n].end_day === 1) && dupes[0] == false){
          activeDays.push('Mon')
          dupes[0] = true
        }
        if((arr[n].start_day === 2 || arr[n].end_day === 2) && dupes[1] == false){
          activeDays.push('Tue')
          dupes[1] = true
        }
        if((arr[n].start_day === 3 || arr[n].end_day === 3) && dupes[2] == false){
          activeDays.push('Wed')
          dupes[2] = true
        }
        if((arr[n].start_day === 4 || arr[n].end_day === 4) && dupes[3] == false){
          activeDays.push('Thu')
          dupes[3] = true
        }
        if((arr[n].start_day === 5 || arr[n].end_day === 5) && dupes[4] == false){
          activeDays.push('Fri')
          dupes[4] = true
        }
        if((arr[n].start_day === 6 || arr[n].end_day === 6) && dupes[5] == false){
          activeDays.push('Sat')
          dupes[5] = true
        }
        if((arr[n].start_day === 0 || arr[n].end_day === 0) && dupes[6] == false){
          activeDays.push('Sun')
          dupes[6] = true
        }
      }
      return activeDays
    },
    getDate(d){
      return formattedDate(this.date_format, d)
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    async getGames () {
      this.loading = true
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/games'
      this.axios.get(url, config)
        .then(response => {
          this.games = response.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })
    },
    goToBilling(){
      this.$router.push('/settings/billing')
    },
    async getSchedules(){
      let token = await this.getAuthToken()
      let config = {headers: {Authorization: token}}
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/schedules'
      this.axios.get(url, config)
        .then(response => {
          this.booking_schedules = response.data.schedules
          this.resource_schedules = response.data.resource_schedules
          let not_all_done_bookings = _.find(this.booking_schedules, {record_creation_completed: 0}) || _.find(this.booking_schedules, {autoblocking_completed: 0})
          let not_all_done_resources = _.find(this.resource_schedules, {record_creation_completed: 0}) || _.find(this.resource_schedules, {autoblocking_completed: 0})

          if(!not_all_done_bookings && !not_all_done_resources && Date.now() > this.poll_grace_until){
            clearInterval(this.polling);
            this.polling = null;
          } else if (!this.polling) {
            // Restart polling if there are incomplete schedules but polling stopped
            this.polling = setInterval(this.getSchedules, 3000);
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } else {
            this.showDialog({ variant: 'danger', title: 'Error', message: 'Something went wrong' })
          }
        })

    },
  },
  mounted(){
    // if(!(_.find(JSON.parse(localStorage.getItem('features')), {id: 21}))){
    //   this.feature_not_enabled = true
    // } else {
    //   this.feature_not_enabled = false
    // }

    // Check if returning from edit with a specific tab
    const tabType = this.$route.query.tab
    if (tabType === '1') {
      this.switchTab(1) // Switch to resource schedules tab
    }

    this.poll_grace_until = Date.now() + 15000
    this.getSchedules()
    this.polling = setInterval(this.getSchedules, 3000);
    this.getGames()
  },
  beforeDestroy(){
    if(this.polling){
      clearInterval(this.polling);
      this.polling = null;
    }
  }
}
</script>

<style scoped>
.sl-empty-state {
  text-align: center;
  padding: 2.5rem 1rem;
}
.sl-empty-state__hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  max-width: 420px;
  margin: 0.25rem auto 1rem;
}
</style>

<style>
.white-content .empty-state-text {
  color: #344675;
}
.white-content .sl-empty-state__hint {
  color: rgba(0, 0, 0, 0.55);
}
</style>
